import { render, staticRenderFns } from "./TheDocumentTasks.vue?vue&type=template&id=77ac3a1c&scoped=true&"
import script from "./TheDocumentTasks.vue?vue&type=script&lang=js&"
export * from "./TheDocumentTasks.vue?vue&type=script&lang=js&"
import style0 from "./TheDocumentTasks.vue?vue&type=style&index=0&id=77ac3a1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ac3a1c",
  null
  
)

export default component.exports